export const getAlphabet = (uppercase = true): string[] =>
  Array.from({ length: 26 }, (_, i) => String.fromCharCode((uppercase ? 65 : 97) + i));
